const hashString$encoder = new TextEncoder()
export async function hashString(string: string) {
  const data = hashString$encoder.encode(string)
  const hash = await crypto.subtle.digest('SHA-256', data)

  const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hash)))
  return base64Hash
}

export const truncateEllipsis = (input: string, max: number) => {
  if (input.length <= max) return input
  let truncate = input.substring(0, max)
  const lastSpace = truncate.lastIndexOf(' ')
  if (lastSpace > 0) {
    truncate = truncate.substring(0, lastSpace)
  }
  return `${truncate} ...`
}

export const truncate = (input: string, max: number) => {
  if (input.length <= max) return input

  return input.substring(0, max)
}

export const hasTextOrEmptyPlaceholder = (input: string | null | undefined) => {
  return input && input.length ? input : '-'
}

export function formatFirstName(prenom: string): string {
  const lower = prenom.trim().toLocaleLowerCase('fr-FR')
  return lower.replace(/(^|[\s\-'])(\p{L})/gu, (_, sep, c) => sep + c.toLocaleUpperCase('fr-FR'))
}
